import { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

/**
 * PublicPage — renders /privacy or /terms from the backend `page_docs`
 * collection. Content is markdown edited by the admin panel.
 */
export default function PublicPage() {
  const { slug: routeSlug } = useParams();
  const loc = useLocation();
  const slug = routeSlug || (loc.pathname.replace(/^\//, "").split("/")[0] || "privacy");
  const [page, setPage] = useState(null);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    setBusy(true);
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data.page))
      .catch(() => setPage(null))
      .finally(() => setBusy(false));
    document.title = slug === "terms" ? "Terms of Service — Jixxeo Apps" : "Privacy Policy — Jixxeo Apps";
  }, [slug]);

  return (
    <div data-testid={`public-page-${slug}`} className="max-w-3xl mx-auto px-4 py-8 pb-24">
      <Link to="/" data-testid="page-back" className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-white/60 hover:text-white mb-4">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to Jixxeo Apps
      </Link>
      {busy ? (
        <div className="py-16 text-center text-white/40"><Loader2 className="w-5 h-5 animate-spin mx-auto" /></div>
      ) : !page ? (
        <div className="py-16 text-center text-white/50">Page not found.</div>
      ) : (
        <article className="prose prose-invert max-w-none prose-headings:font-black prose-headings:tracking-tight prose-h1:text-4xl prose-h2:text-2xl prose-a:text-[#00F0FF] prose-a:no-underline hover:prose-a:underline prose-strong:text-white">
          <ReactMarkdown>{page.body_md}</ReactMarkdown>
          <p className="mt-10 text-xs text-white/40">
            Last updated: {(page.updated_at || page.created_at || "").slice(0, 10)}
          </p>
        </article>
      )}
    </div>
  );
}
